/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseWorklist } from '../../models/course-worklist';
import { CriteriaCourseWorklist } from '../../models/criteria-course-worklist';

export interface ApiWorklistMyRequestPost$Params {
      body?: CriteriaCourseWorklist
}

export function apiWorklistMyRequestPost(http: HttpClient, rootUrl: string, params?: ApiWorklistMyRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CourseWorklist>>> {
  const rb = new RequestBuilder(rootUrl, apiWorklistMyRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CourseWorklist>>;
    })
  );
}

apiWorklistMyRequestPost.PATH = '/api/Worklist/MyRequest';
